import {Injectable} from '@angular/core';
import {collection, Firestore, getDocs, query, where} from '@angular/fire/firestore';
import {BaseDaoService, handleError, SessionService} from '@q9elements/ui-kit/common';
import {FilterDescriptors, GridStore} from '@q9elements/ui-kit/components';

import {VIEWS_COLLECTION} from '../models/constants';
import {GridView} from '../models/interfaces';

@Injectable()
export class GridViewsDaoService extends BaseDaoService {
  constructor(
    private store: GridStore,
    private firestore: Firestore,
    private sessionService: SessionService
  ) {
    super();
  }

  create(payload: Partial<GridView>) {
    return this.http.post<GridView>(`${this.apiUrl}/grid-views`, payload).pipe(handleError());
  }

  update(id: string, payload: Partial<GridView>) {
    return this.http.put<GridView>(`${this.apiUrl}/grid-views/${id}`, payload);
  }

  delete(id: string) {
    return this.http.delete(`${this.apiUrl}/grid-views/${id}`).pipe(handleError());
  }

  storeFilters(viewId: string, payload: FilterDescriptors) {
    return this.http
      .post<FilterDescriptors>(`${this.apiUrl}/grid-views/${viewId}/filters`, payload)
      .pipe(handleError());
  }

  async fetchViews() {
    const q = query(
      collection(this.firestore, VIEWS_COLLECTION),
      where('type', '==', this.store.storeName),
      where('team', '==', this.sessionService.teamId())
    );
    const views: GridView[] = [];

    const querySnapshot = await getDocs(q);

    if (querySnapshot.size) {
      querySnapshot.docs.forEach(doc => views.push(doc.data() as GridView));
    }

    return views;
  }
}
